<template>
  <div>
    <b-card class="shadow">
      <div class="row">
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-between mb-4">
            <div>
              <h5 class="mb-3 text-gray-800">
                {{ $t("Todos os Usuários") }}
              </h5>
            </div>

            <b-button-group>
              <b-button
                variant="outline-dark"
                :class="viewFilterReport === true ? 'active' : ''"
                @click="viewFilters"
              >
                <i class="fas fa-filter"></i>
                {{ $t("Filtros") }}
              </b-button>
              <b-button variant="outline-dark" @click="print()">
                <i class="fas fa-print"></i>
              </b-button>
              <b-button
                variant="outline-dark"
                @click="exportar()"
                :title="$t('Exportar')"
                v-b-tooltip.hover
              >
                <i class="fas fa-file-excel"></i>
              </b-button>
            </b-button-group>
          </div>
        </div>

        <div class="col-12" v-if="viewFilterReport">
          <form @submit.prevent="getUsuario" ref="formFiltros">
            <div class="row">
              <div class="col-md-8">
                <label><b>Pesquisar</b></label>
                <div class="input-group">
                  <b-input
                    placeholder="No campo acima você pode pesquisar por: ID, Código Cadúnico, Nome Completo, CPF ou NIS"
                    class="form-control search-input"
                    type="text"
                    v-model="search"
                    aria-describedby="input-search"
                    @keydown.enter.prevent="getUsuario"
                  />
                  <div
                    class="input-group-append"
                    role="button"
                    @click.prevent="getUsuario"
                  >
                    <span class="input-group-text" id="input-search"
                      ><i class="fas fa-search search-icon"
                    /></span>
                  </div>
                </div>
                <p class="small text-muted">
                  No campo acima você pode pesquisar por: ID, Código Cadúnico,
                  Nome Completo, CPF, NIS, Código familiar ou ID da família
                </p>
              </div>

              <form-select
                v-model="filtroOutras"
                grid="4"
                label="Outras Opções"
                :itens="[
                  { id: 1, value: 'Usuário sem NIS' },
                  { id: 2, value: 'Usuário sem CPF' },
                  {
                    id: 3,
                    value: 'Usuário cadastrado manualmente',
                  },
                  {
                    id: 4,
                    value: 'Usuário Sem Data de Nascimento',
                  },
                  {
                    id: 5,
                    value: 'Usuário em situação de rua',
                  },
                ]"
              />

              <form-calendar
                v-model="data_inicio"
                grid="4"
                label="Data Inicial"
              />

              <form-calendar
                v-model="data_fim"
                grid="4"
                label="Data Final"
                :required="verificaDataInicial"
              />

              <form-select
                v-model="filtroStatus"
                grid="4"
                label="Estado Cadastral"
                :itens="$root.arrays.estado_cadastral"
              />

              <form-select
                v-model="fazUsoDrogas"
                grid="4"
                label="Faz uso abusivo de drogas?"
                :itens="[
                  { id: 1, value: 'Sim' },
                  { id: 2, value: 'Não' },
                ]"
              />

              <form-select
                v-model="fazUsoAlcool"
                grid="4"
                label="Faz uso abusivo de álcool?"
                :itens="[
                  { id: 1, value: 'Sim' },
                  { id: 2, value: 'Não' },
                ]"
              />

              <form-toggle
                v-if="filtroOutras != 4"
                v-model="showfiltroIdade"
                grid="12"
                label="Filtrar por intervalo de idade?"
              />

              <div
                class="col-md-12 mt-3 mb-5"
                v-if="showfiltroIdade == true && filtroOutras != 4"
              >
                <label><b>Idade</b></label>
                <vue-slider
                  v-model="filtroIdade"
                  :min="min"
                  :max="max"
                  :tooltip="'always'"
                  :tooltip-placement="'bottom'"
                ></vue-slider>
              </div>

              <form-toggle
                v-model="showfiltroNomeSocial"
                grid="12"
                label="Filtrar por Nome Social"
              />

              <div class="col-md-8" v-if="showfiltroNomeSocial">
                <label><b>Nome Social</b></label>
                <div class="input-group">
                  <b-input
                    placeholder="Nome Social"
                    class="form-control search-input"
                    type="text"
                    v-model="filtroNomeSocial"
                    aria-describedby="input-search"
                    @keydown.enter.prevent="getUsuario"
                  />
                  <div
                    class="input-group-append"
                    role="button"
                    @click.prevent="getUsuario"
                  >
                    <span class="input-group-text" id="input-search"
                      ><i class="fas fa-search search-icon"
                    /></span>
                  </div>
                </div>
              </div>

              <form-select
                v-if="showfiltroNomeSocial"
                grid="4"
                v-model="filtroOrigemNomeSocial"
                :itens="$root.arrays.origem_nome_social"
                label="Origem do Nome Social"
                multiple
              />
            </div>
            <div class="row pt-2 mb-4 px-0 d-flex justify-content-end">
              <div class="col-auto px-2 text-right">
                <button
                  class="btn btn-default btn-sm"
                  @click.prevent="
                    limparFiltros();
                    viewFilterReport = false;
                  "
                >
                  <i class="fas fa-times"></i>
                </button>

                <button
                  type="button"
                  class="btn btn-secondary btn-sm"
                  @click.prevent="limparFiltros()"
                >
                  {{ $t("Limpar Filtros") }}
                </button>
                <button
                  class="btn btn-success btn-submit btn-sm"
                  data-style="zoom-in"
                  type="submit"
                >
                  <i class="fas fa-chart-bar"></i>
                  {{ $t("Filtrar") }}
                </button>
              </div>
            </div>
          </form>
        </div>

        <load mode="table" v-if="loading" message="Carregando Famílias" />
        <div v-else class="col-12">
          <print-content>
            <template v-slot:datas>
              <p class="d-flex align-items-center justify-content-between mb-4">
                <span
                  >Período selecionado:
                  <b>{{ datas.start }} - {{ datas.end }}</b>
                  <b-link
                    href="#"
                    @click.prevent="void 0"
                    class="mb-2"
                    variant="info"
                    v-b-popover.hover.top="
                      'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                    "
                  >
                    <i class="fas fa-info-circle"></i> </b-link
                ></span>

                <span v-if="pagination.total"
                  >Total de Registros <b>{{ pagination.total }}</b
                  >, total por página <b>{{ pagination.perPage }}</b></span
                >
              </p>
            </template>
            <b-table
              :fields="[
                {
                  key: 'nome_completo',
                  label: $t('Nome Completo'),
                },
                {
                  key: 'mae',
                  label: $t('Filiação 1'),
                },
                {
                  key: 'estado_cadastral',
                  label: $t('Estado Cadastral'),
                },
                {
                  key: 'cadastro',
                  label: $t('Datas'),
                },
                {
                  key: 'actions',
                  label: '',
                  class: 'text-right no-print',
                  thStyle: {
                    width: '95px',
                    minWidth: '95px',
                  },
                },
              ]"
              :items="UsuarioList"
              :responsive="true"
              striped
              hover
              show-empty
              small
              outlined
              stacked="xs"
              table-class="mb-3"
            >
              <template v-slot:cell(nome_completo)="data">
                <strong
                  v-if="data.item.nome_completo"
                  v-html="
                    $options.filters.highlight(data.item.nome_completo, search)
                  "
                ></strong>
                <span class="d-block" v-if="showfiltroNomeSocial">
                  <span class="d-block">
                    Nome Social:
                    <strong
                      v-if="data.item.nome_social"
                      v-html="
                        $options.filters.highlight(
                          data.item.nome_social,
                          filtroNomeSocial
                        )
                      "
                    ></strong
                  ></span>
                  <span class="d-block" v-if="data.item.origem_nome_social">
                    Origem:
                    <strong>{{
                      data.item.origem_nome_social_formatado
                    }}</strong></span
                  > </span
                ><br />

                <small class="text-muted">
                  Data de Nascimento:
                  <span v-if="data.item.data_nascimento">
                    {{ data.item.data_nascimento }}
                    <span v-if="data.item.idade">
                      ({{ parseInt(data.item.idade) }} ano(s))
                    </span>
                  </span>
                  <alert-icon v-else message="Data de Nascimento em branco" />
                  <br />
                  Posição Familiar:
                  {{ data.item.posicao_familiar_nome }}
                  <br />
                  <span v-if="data.item.documento">
                    CPF:
                    <strong
                      v-if="data.item.documento.cpf"
                      v-html="
                        $options.filters.highlight(
                          data.item.documento.cpf,
                          search
                        )
                      "
                    ></strong>

                    <alert-icon
                      v-if="data.item.documento.cpf == null"
                      message="Não sabe o número do CPF ou não foi inserido no cadastro!"
                    />
                  </span>
                  <span v-else>
                    Documento:
                    <alert-icon
                      message="Pessoa sem documentação ou não foi inserido no cadastro!"
                    />
                  </span>
                </small>
                <br />
                <small v-if="data.item.codigo_usuario_cadunico">
                  <b>Código no Cad Único</b>
                  {{ data.item.codigo_usuario_cadunico }}
                </small>
                <small v-else> <b>ID no Sistema</b> {{ data.item.id }} </small>
              </template>

              <template v-slot:cell(mae)="data">
                <strong>{{ data.item.mae }}</strong>
              </template>
              <template v-slot:cell(estado_cadastral)="data">
                <span class="small" v-html="data.item.estado_cadastral"></span>
              </template>

              <template v-slot:cell(cadastro)="data">
                <span class="small text-muted d-block">
                  Criado em: {{ data.item.cadastro }}
                </span>
                <span class="small text-muted d-block"
                  >Atualizado em:
                  {{ data.item.atualizacao }}
                </span>
                <span
                  class="small text-muted d-block"
                  v-if="data.item.cadastro_cadunico"
                >
                  Cadastrado no Cadúnico em:
                  {{ data.item.cadastro_cadunico }}
                </span>
                <span
                  class="small text-muted d-block"
                  v-if="data.item.atualizacao_cadunico"
                  >Atualizado no Cadúnico em:
                  {{ data.item.atualizacao_cadunico }}
                  <b-link
                    v-if="data.item.alert_atualizacao_cadunico > 1"
                    href="#"
                    v-b-tooltip.hover
                    :title="`Atualizado há ${data.item.alert_atualizacao_cadunico} anos no Cadúnico`"
                  >
                    <b-icon
                      icon="exclamation-triangle-fill"
                      variant="warning"
                      animation="fade"
                    ></b-icon>
                  </b-link>
                </span>
              </template>
              <template v-slot:cell()="data">
                <b-button
                  :title="$t('Editar Usuário')"
                  :to="`/dashboard/usuario/edit/${data.item.id}`"
                  target="_blank"
                  class="px-2 mb-0"
                  size="xs"
                  type="button"
                  v-b-tooltip.hover
                  variant="success"
                >
                  <i class="mdi mdi-square-edit-outline" />
                </b-button>
              </template>
              <template v-slot:empty="scope">
                <div class="text-center my-5">
                  <img
                    :alt="$t('No results')"
                    class="mb-5"
                    src="/img/icons/robot.svg"
                    style="max-height: 165px"
                  />
                  <h3 class="bold">
                    {{ $t("No records found") }}
                  </h3>
                </div>
              </template>
            </b-table>
          </print-content>
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
              <div class="form-group d-inline-flex mb-0">
                <select
                  class="form-control"
                  style="width: 70px"
                  v-model="perPage"
                  v-on:change="getFamilias"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
              <div class="d-inline-flex ml-2">
                <b-pagination
                  :per-page="perPage"
                  :total-rows="pagination.total"
                  @change="changePage"
                  v-model="page"
                />
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
              <div class="float-lg-right">
                {{ $t("Showing page") }}
                {{ pagination.currentPage }}
                {{ $t("of") }}
                {{ pagination.totalPages }}
                {{ $t("pages in") }}
                {{ pagination.total }}
                {{ $t("records") }}
              </div>
            </div>
          </div>

          <div class="box-btn-print no-print">
            <b-button
              v-if="!loading"
              :title="$t('Visualizar e Imprimir')"
              class="py-2"
              size="sm"
              type="button"
              v-b-tooltip.hover
              variant="primary"
              @click="print()"
            >
              <i class="fas fa-print"></i>
            </b-button>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "Usuario",
  metaInfo() {
    return {
      title: this.$i18n.t("Gestão de Usuário"),
    };
  },
  data() {
    return {
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      UsuarioList: [],
      status: "",
      datas: {},
      idades: null,
      filtroStatus: null,
      filtroDatas: [],
      filtroIdade: [],
      filtroOutras: null,
      showfiltroIdade: false,
      showfiltroNomeSocial: false,
      filtroNomeSocial: "",
      filtroOrigemNomeSocial: [],
      fazUsoDrogas: null,
      fazUsoAlcool: null,
    };
  },
  watch: {
    filtroOutras(val) {
      this.filtroIdade = val == 4 ? [] : [0, 120];
      this.showfiltroIdade = val == 4 ? false : true;
    },
    showfiltroIdade(val) {
      this.filtroIdade = val ? [0, 120] : [];
    },
  },
  created() {
    this.min = 0;
    this.max = 120;
    this.enableCross = false;
  },
  mounted() {
    this.getUsuario();
  },
  methods: {
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getUsuario();
      }
    },
    getUsuario() {
      this.loading = true;

      this.datas.start = this.$options.filters.formatDate(this.data_inicio);
      this.datas.end = this.$options.filters.formatDate(this.data_fim);

      if (this.filtroIdade && this.filtroIdade.length > 0) {
        this.idades =
          "Usuários com Idade entre: " +
          this.filtroIdade[0] +
          " ano(s) e " +
          this.filtroIdade[1] +
          " ano(s)";
      }

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      axios
        .get("api/dashboard/report/usuarios/home", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
            filtroIdade: this.filtroIdade.length > 0 ? this.filtroIdade : null,
            filtroOutras: this.filtroOutras,
            filtroNomeSocial: this.filtroNomeSocial,
            filtroOrigemNomeSocial: this.filtroOrigemNomeSocial,
            fazUsoDrogas: this.fazUsoDrogas,
            fazUsoAlcool: this.fazUsoAlcool,
          },
        })
        .then((response) => {
          this.UsuarioList = response.data.dados;
          this.pagination = response.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getUsuario();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/report/usuarios/home", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
            filtroIdade: this.filtroIdade.length > 0 ? this.filtroIdade : null,
            filtroOutras: this.filtroOutras,
            filtroNomeSocial: this.filtroNomeSocial,
            filtroOrigemNomeSocial: this.filtroOrigemNomeSocial,
            export: "ok",
            fazUsoDrogas: this.fazUsoDrogas,
            fazUsoAlcool: this.fazUsoAlcool,
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    deleteUsuario(id) {
      swal
        .fire({
          title: this.$t("Are you sure?"),
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: this.$t("Delete"),
          icon: "warning",
        })
        .then((value) => {
          if (value) {
            this.loading = true;
            axios
              .delete("api/dashboard/usuarios/" + id)
              .then((response) => {
                this.getUsuario();
                this.$snack.success({
                  button: false,
                  text: response.data.data.message,
                });
              })
              .catch(() => {
                this.loading = false;
              });
          }
        });
    },
    importarUsuarios() {
      let ladda = Ladda.create(document.querySelector(".btn-importar"));
      ladda.start();

      this.$snack.show({
        button: false,
        text: "A importação foi iniciada e você receberá um e-mail quando for concluída.",
      });

      axios.post("api/dashboard/importar/usuarios").then((response) => {
        this.getUsuario();

        this.$snack.show({
          button: false,
          text: response.data.data.message,
        });

        ladda.stop();
      });
    },
    limparFiltros() {
      this.search = "";
      this.filtroStatus = null;
      this.filtroDatas = [];
      this.data_inicio = "";
      this.data_fim = "";
      this.filtroIdade = [];
      this.showfiltroIdade = false;
      this.filtroOutras = null;

      this.showfiltroNomeSocial = false;
      this.filtroNomeSocial = "";
      this.filtroOrigemNomeSocial = [];
      this.fazUsoDrogas = null;
      this.fazUsoAlcool = null;

      this.getUsuario();
    },
    // exportar() {
    //     this.loading = true;
    //     this.filtroDatas = [];
    //     if (this.data_inicio) {
    //         this.filtroDatas.push(
    //             this.$options.filters.formatDateYMD(this.data_inicio)
    //         );
    //     }
    //     if (this.data_fim) {
    //         this.filtroDatas.push(
    //             this.$options.filters.formatDateYMD(this.data_fim)
    //         );
    //     }
    //     swal.fire({
    //         title: "Aguarde",
    //         text: "O Arquivo está sendo gerado.",
    //         imageUrl: `${window.urlbase}img/load.gif`,
    //         showConfirmButton: false,
    //     });
    //     axios
    //         .get("api/dashboard/usuario/export/excel", {
    //             params: {
    //                 page: this.page,
    //                 search: this.search,
    //                 perPage: this.perPage,
    //                 filtroStatus: this.filtroStatus,
    //                 filtroDatas: this.filtroDatas,
    //                 filtroIdade:
    //                     this.filtroIdade.length > 0
    //                         ? this.filtroIdade
    //                         : null,
    //                 filtroOutras: this.filtroOutras,
    //                 filtroNomeSocial: this.filtroNomeSocial,
    //                 filtroOrigemNomeSocial: this.filtroOrigemNomeSocial,
    //             },
    //         })
    //         .then((response) => {
    //             swal.fire({
    //                 title: "Arquivo Pronto para Download!",
    //                 html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
    //                 icon: "success",
    //                 showConfirmButton: false,
    //             });
    //         })
    //         .finally(() => (this.loading = false));
    // },
  },
};
</script>
